export const valueMap = {
  unitedState: 'I am a citizen of the United States',
  presidentResident: 'I am a lawful permanent resident',
  ead: 'I am a non-citizen national of the United States',
  temporaryVisa: 'I am a non-citizen authorized to work',

  // -----------------------------
  usPassport: 'US Passport',
  permanentResidentCard: 'Permanent Resident Card',
  employmentAuthorizationDocument: 'Employment Authorization Document',
  // temporaryVisa: 'Temporary Visa',

  driverLicence: "Driver's License",
  stateID: 'State ID',
  voterRegistrationCard: 'Voter Registration Card',
  schoolID: 'School ID',
  militaryID: 'Military ID',
  militaryDependentsID: 'Military Dependents ID',
  merchantMarinerCard: 'Merchant Mariner Card',
  nativeAmericanTribalDoc: 'Native American Tribal Document',
  canadianDriversLicence: 'Canadian Driver\'s License',
  socialSecurityCard: 'Social Security Card',
  certificationOfBirthAbroad: 'Certification of Birth Abroad',
  certificationofReportOfBirth: 'Certification of Report of Birth',
  birthCertificate: 'Birth Certificate',
  nativeAmericanTribalDoc: 'Native American Tribal Document',
  usCitizenIdCard: 'US Citizen ID Card',
  residentCitizenIdCard: 'Resident Citizen ID Card',

  aNumber: "USCIS or A-Number",
  passportNumber: "Foreign Passport",
  i94Number: "Form I-94"
};

export const US_STATES = [
  "Alabama", "Alaska", "Arizona", "Arkansas", "California", "Colorado", "Connecticut", "Delaware",
  "Florida", "Georgia", "Hawaii", "Idaho", "Illinois", "Indiana", "Iowa", "Kansas", "Kentucky",
  "Louisiana", "Maine", "Maryland", "Massachusetts", "Michigan", "Minnesota", "Mississippi",
  "Missouri", "Montana", "Nebraska", "Nevada", "New Hampshire", "New Jersey", "New Mexico",
  "New York", "North Carolina", "North Dakota", "Ohio", "Oklahoma", "Oregon", "Pennsylvania",
  "Rhode Island", "South Carolina", "South Dakota", "Tennessee", "Texas", "Utah", "Vermont",
  "Virginia", "Washington", "West Virginia", "Wisconsin", "Wyoming", "District of Columbia"
];
